






























































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonCancelSaveRpa extends Vue {
  get isEditMode() {
    return this.$route.meta.mode === "EDIT";
  }

  get isViewMode() {
    return this.$route.meta.mode === "VIEW";
  }

  get isAddMode() {
    return this.$route.meta.mode === "ADD";
  }

  created() {
  }

  onSave() {
    this.$store.commit("SAVE_RPA_CLICK");
  }

  getRouteCancel() {
    this.$router.push({ name: "rpa" });
  }

  getRouteEditRPA() {
    this.$router.push({ name: "edit-rpa", params: { id: this.$route.params.id } });
  }
}
